import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=0be5cf50"
import script from "./NavigationItem.vue?vue&type=script&lang=js"
export * from "./NavigationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports